const useStyles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default useStyles;
